// extracted by mini-css-extract-plugin
export default {"preview":"style_preview__0EOeW"};